<template>
  <div class="px-8">
    <div class="font-bold text-deep-dark mb-2">
      {{ $t('frontend_groovevideo_publish_heading') }}
    </div>
    <div class="text-deep-dark text-sm">
      {{
        $t('frontend_groovevideo_publish_desc', {
          privacy: localModel.privacy,
        })
      }}
    </div>
    <div class="flex flex-row items-center mt-6">
      <groove-video-icon class="mr-2" />
      <div class="text-deep-dark flex">
        {{ $t('frontend_groovevideo_publish_groove') }}
        <div class="font-bold">
          {{ $t('frontend_groovevideo_publish_groove_video') }}
        </div>
      </div>
      <right-arrow class="h-4 mx-6 text-grey-500 fill-current" />
      <youtube-icon />
    </div>
  </div>
</template>

<script>
import RightArrow from '@fortawesome/fontawesome-free/svgs/solid/arrow-right.svg';
import grooveVideoIcon from '@/assets/images/icons/GrooveVideoIcon.svg';
import youtubeIcon from '@/assets/images/icons/YouTube.svg';

export default {
  props: {
    model: {
      required: true,
    },
  },
  components: {
    grooveVideoIcon,
    youtubeIcon,
    RightArrow,
  },
  data() {
    return {
      localModel: this.model,
    };
  },
  methods: {
    validate() {
      return true;
    },
  },
};
</script>